import { Component, Input } from '@angular/core';
import { CaseStudy } from '../hub-case-studies-list.component';

@Component({
  selector: 'hub-case-study-card',
  templateUrl: './hub-case-study-card.component.html',
  styleUrls: ['./hub-case-study-card.component.scss']
})
export class HubCaseStudyCardComponent {
  @Input() caseStudy!: CaseStudy;

  openCard(): void {
    window.open(this.caseStudy.url, '_blank');
  }
}
